/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MilestoneUpdateRequest
 */
export interface MilestoneUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneUpdateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneUpdateRequest
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof MilestoneUpdateRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MilestoneUpdateRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MilestoneUpdateRequest
     */
    completedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof MilestoneUpdateRequest
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof MilestoneUpdateRequest
     */
    sequence?: number;
    /**
     * 
     * @type {string}
     * @memberof MilestoneUpdateRequest
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneUpdateRequest
     */
    assignee?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneUpdateRequest
     */
    priority?: string;
    /**
     * 
     * @type {number}
     * @memberof MilestoneUpdateRequest
     */
    allocatedAmount?: number;
}

/**
 * Check if a given object implements the MilestoneUpdateRequest interface.
 */
export function instanceOfMilestoneUpdateRequest(value: object): value is MilestoneUpdateRequest {
    return true;
}

export function MilestoneUpdateRequestFromJSON(json: any): MilestoneUpdateRequest {
    return MilestoneUpdateRequestFromJSONTyped(json, false);
}

export function MilestoneUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'completedDate': json['completedDate'] == null ? undefined : (new Date(json['completedDate'])),
        'status': json['status'] == null ? undefined : json['status'],
        'sequence': json['sequence'] == null ? undefined : json['sequence'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'assignee': json['assignee'] == null ? undefined : json['assignee'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'allocatedAmount': json['allocatedAmount'] == null ? undefined : json['allocatedAmount'],
    };
}

export function MilestoneUpdateRequestToJSON(json: any): MilestoneUpdateRequest {
    return MilestoneUpdateRequestToJSONTyped(json, false);
}

export function MilestoneUpdateRequestToJSONTyped(value?: MilestoneUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'completedDate': value['completedDate'] == null ? undefined : ((value['completedDate']).toISOString()),
        'status': value['status'],
        'sequence': value['sequence'],
        'remarks': value['remarks'],
        'assignee': value['assignee'],
        'priority': value['priority'],
        'allocatedAmount': value['allocatedAmount'],
    };
}

